import { SurgeryLocation } from './surgery-location';

export interface SurgeryLocationsResponse {
    current_page:   number;
    data:           SurgeryLocation[];
    first_page_url: string;
    last_page:      number;
    last_page_url:  string;
    links:          Link[];
    next_page_url:  string | null;
    path:           string;
    per_page:       number;
    prev_page_url:  string | null;
    to:             number;
    total:          number;
}

interface Link {
    url:    null;
    label:  string;
    active: boolean;
}
